import Swiper from 'swiper';
import { A11y, EffectFade, Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiperContainers = document.querySelectorAll('.swiper-features');

  swiperContainers.forEach(container => {
    const swiperInstance = new Swiper(container, {
      modules: [Pagination, A11y, EffectFade, Navigation],
      slidesPerView: 1,
      effect: 'fade',
      pagination: {
        enabled: true,
        el: container.querySelector('.swiper-pagination-features'),
        type: 'fraction',
        // clickable: true,
      },
      navigation: {
        nextEl: container.querySelector('.btn-features-next'),
        prevEl: container.querySelector('.btn-features-prev'),
        enabled: true,
      },
      breakpoints: {
        992: {
          allowTouchMove: false,
          pagination: { enabled: false },
          navigation: { enabled: false },
        },
      },
    });
    container.swiperInstance = swiperInstance;

    // const swiperSlides = swiper_features_selector.querySelectorAll('.swiper-slide');
    // const swiperPagination = swiper_features_selector.querySelector('.swiper-pagination');

    // if (swiperPagination) {
    // 	const paginationHeight = swiperPagination.offsetHeight;

    // 	swiperSlides.forEach(slide => {
    // 		const currentPaddingBottom = parseFloat(window.getComputedStyle(slide).paddingBottom);
    // 		slide.style.paddingBottom = `${currentPaddingBottom + paginationHeight}px`;
    // 	});
    // }
    if (window.matchMedia('screen and (min-width:992px)').matches) {
      const featuresFlex = container.closest('.features-flex');
      if (featuresFlex) {
        const icons = featuresFlex.querySelectorAll('.description-icon');
        icons.forEach(icon => {
          icon.addEventListener('click', function () {
            const dataId = this.dataset.id;
            icons.forEach(i => i.classList.remove('active'));
            this.classList.add('active');
            swiperInstance.slideTo(dataId, 0);
          });
          icon.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
              const dataId = icon.dataset.id;
              icons.forEach(i => i.classList.remove('active'));
              icon.classList.add('active');
              swiperInstance.slideTo(dataId, 0);
            }
          });
        });
      }
    }
  });

  const menuLinks = document.querySelectorAll('.tab-menu .menu-link');
  menuLinks.forEach(button => {
    button.addEventListener('click', function () {
      setTimeout(() => {
        swiperContainers.forEach(container => {
          if (container.offsetParent !== null && container.swiperInstance) {
            container.swiperInstance.update();
          }
        });
      }, 50);
    });
  });
});
